import axios, { type AxiosResponse } from 'axios';
import { baseUrl, HttpMethods } from '../../base';
import type {
  ChallengeVideosResponse,
  IGetClientAccountService,
  IGetClientAccountServiceRes,
  IPatchClientAccountService,
  IPostClientAccountResendOnboardInvitationService,
  OrganizationInfoPayload,
} from './types';

export async function getClientAccount({ accountId, params }: IGetClientAccountService): Promise<IGetClientAccountServiceRes> {
  const res = await axios.request<IGetClientAccountServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.OS}/accounts/${accountId}`,
    params,
  });
  return res.data;
}

export async function patchClientAccount({ accountId, data }: IPatchClientAccountService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/accounts/${accountId}`,
    data,
  });
  return res.data;
}

export async function postClientAccountResendOnboardInvitation({ accountId }: IPostClientAccountResendOnboardInvitationService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/accounts/resend_onboard_invitation/${accountId}`,
  });
  return res.data;
}

export const storeOrganizationInfo = async (payload: OrganizationInfoPayload): Promise<AxiosResponse> => {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/stpdemo`,
    data: payload,
  });
  return res;
};

export const fetchChallengeVideos = async (challengeIds: string[]): Promise<ChallengeVideosResponse> => {
  const res = await axios.request<ChallengeVideosResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/stpdemo/challenge-videos`,
    params: {
      challenges: challengeIds.join(','),
    },
  });
  return res.data;
};

export const fetchStpDemoApplications = async (params: unknown): Promise<unknown> => {
  const res = await axios.request<unknown>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/stpdemo/application-list`,
    params,
  });
  return res.data;
};

export const bulkDeleteApplications = async (applicationIds: number[]): Promise<unknown> => {
  const res = await axios.request<unknown>({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/stpdemo/application-list`,
    data: { applicationIds },
  });
  return res.data;
};

export const updateApplicationStatus = async (applicationId: number, status: string): Promise<unknown> => {
  const res = await axios.request<unknown>({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/stpdemo/application-list/${applicationId}/status`,
    data: { status },
  });
  return res.data;
};
